<template>
    <div class="page-device">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="24" :lg="12" :xl="12" class="m-b-md-10">
                    <h2 class="m-b-0">{{deviceName}}</h2>
                </el-col>
                <el-col :sm="24" :md="24" :lg="12" :xl="12" align="right" class="page-device__reset">
                    <el-button v-if="deviceFromList.Type >= 1 && deviceFromList.Type <= 3" type="primary" icon="el-icon-refresh" @click="rebootDevice" :loading="rebootLoading">Перезагрузка</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-card v-if="deviceFromList.Type >= 1 && deviceFromList.Type <= 3" shadow="never" class="m-b-20" >
                    <h2 class="m-b-20">Режим работы</h2>
                    <el-select @change="changeMode" v-model="deviceFromList.Mode.Value" placeholder="Выберите режим работы стойки" class="w-50">
                        <el-option
                                v-for="item in modeDict"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-card>
                <el-card v-if="deviceFromList.Type === 5" shadow="never" class="m-b-20" >
                    <h2 class="m-b-20">Значение на табло</h2>
                    <div class="d-flex">
                        <el-input v-model="deviceFromList.FreePlaces.Value" placeholder="Задать параметр" class="m-r-20"></el-input>
                        <el-button type="primary" @click="setTabloParam">Задать</el-button>
                    </div>
                </el-card>

                <el-card shadow="never" class="m-b-20 el-card--with-table">
                    <div slot="header" class="clearfix">
                        <h2>Параметры и сообщения</h2>
                    </div>
                    <div v-if="!$mobile()">
                        <div v-for="(item, key) in alarmsTable" :key="key">
                            <card
                                v-loading="loading"
                                :icon="item.Level"
                                :title="item.Name"
                                :date="item.Time"
                                :description="item.Name + ': ' + item.Value"
                            >
                            </card>
                        </div>
                    </div>
                    <div v-else>
                        <el-table v-loading="loading" :data="alarmsTable" :default-sort="{prop: 'Time', order: 'descending'}">
                            <el-table-column prop="Level" label="" width="60px">
                                <template slot-scope="scope">
                                    <icon :level="scope.row.Level"></icon>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Time" label="Время">
                                <template slot-scope="scope">
                                    <table-date :date="scope.row.Time"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Name" label="Параметр" />
                            <el-table-column prop="Value" label="Описание" />
                        </el-table>
                    </div>
                </el-card>
            </el-col>
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <ItemViewTable v-if="dataTable.length" v-loading="loading" :dataTable="dataTable"></ItemViewTable>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                loading: false,
                dataTable: [],
                alarmsTable: [],
                form: {},
                zonesDict: [],
                deviceName: '',
                rebootLoading: false,
                deviceFromList: {},
                modeDict: [
                    { id: 0, value: 'Не определен' },
                    { id: 1, value: 'Заблокирована' },
                    { id: 2, value: 'Штатный' },
                    { id: 3, value: 'Свободный проезд с зелёным светофором' },
                    { id: 4, value: 'Свободный проезд с красным светофором' },
                    { id: 5, value: 'Свободный проезд одного автомобиля' },
                    { id: 6, value: 'Выпустить инвалида' }
                ],
                deviceId: this.$route.params.id
            }
        },
        computed: {
            ...mapGetters(['user']),
        },
        methods: {
            getData () {
                this.loading = true

                let request = {
                    Name: "GetItemView",
                    ItemType: "Device",
                    OperatorName: "Admin",
                    ItemId: this.deviceId
                }

                this.$api.Main.getDevices(request).then(response => {
                    this.dataTable = response.Parameters
                    this.loading = false

                    this.dataTable.map(row => {
                        if (row.View.DisplayName === 'Имя') this.deviceName = row.Value
                    })

                    request.Name = "GetItemsList"
                    request.Filter = {
                        Type: "Simple",
                        Field: "ID",
                        Operation: "Equal",
                        Value: this.deviceId
                    }

                    this.$api.Main.getDevices(request).then(response => {
                        this.deviceFromList = response.Items[0]
                    })
                })
            },
            getAlarms () {
                let request = {
                    Name: "GetActualAlarms",
                    Filter: {
                        Type: "Simple",
                        Field: "DeviceId",
                        Operation: "Equal",
                        Value: this.deviceId
                    }
                }

                this.$api.Main.getAlarms(request).then(response => {
                    this.alarmsTable = response.Alarms
                })
            },
            rebootDevice () {
                let request = {
                    Name: 'ExecuteFunction',
                    ItemType: 'Device',
                    FunctionName: 'ShutdownSend',
                    FunctionParameters: [ this.deviceId ]
                }

                this.$api.Main.rebootDevice(request).then(response => {
                    if (response.Result === "Success") {
                        this.$message({
                            message: 'Устройство перезагружено',
                            type: 'success',
                            res: response
                        })
                    }
                    else {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error',
                            res: response
                        })
                    }
                })

                this.rebootLoading = true
                setTimeout(() => { this.rebootLoading = false }, 2000)
            },
            setTabloParam () {
                let request = {
                    Name: 'ExecuteFunction',
                    ItemType: 'Device',
                    FunctionName: 'SetBoardAdjustment',
                    FunctionParameters: [this.deviceId, this.deviceFromList.FreePlaces.Value, '0']
                }

                this.$api.Main.setTabloParam(request).then(response => {
                    if (response.Result === "Success") {
                        this.$message({
                            message: 'Значение на табло скорректированно',
                            type: 'success',
                            res: response
                        })
                    }
                    else {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error',
                            res: response
                        })
                    }
                })
            },
            changeMode () {
                let request = {
                    Name: 'ExecuteFunction',
                    ItemType: 'Device',
                    FunctionName: 'SetStandMode',
                    FunctionParameters: [this.deviceId, this.deviceFromList.Mode.Value, 'False']
                }

                this.$api.Main.setDeviceParam(request).then(response => {
                    if (response.Result === "Success") {
                        this.$message({
                            message: 'Режим изменен',
                            type: 'success',
                            res: response
                        })
                    }
                    else {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error',
                            res: response
                        })
                    }
                })
            }
        },
        mounted () {
            this.getAlarms()
            this.getData()
        }
    }
</script>
